import React, { FunctionComponent } from 'react'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { ChartOptions } from 'chart.js'

import { IProps } from './IProps'
import { GraphContainer } from './style'

export const PerformanceGraph: FunctionComponent<IProps> = ({
    performanceStats,
}) => {
    const { t } = useTranslation()

    const data = {
        labels: [t('Chosen'), t('Random')],
        datasets: [
            {
                label: '',
                data: [
                    performanceStats.loyalty.chosenCount,
                    performanceStats.loyalty.randomCount,
                ],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 0,
            },
        ],
    }
    const options: ChartOptions<'bar'> = {
        // TODO should be a horizontal barChart
        indexAxis: 'y' as const,
        scales: {
            yAxes: {
                ticks: {
                    // beginAtZero: true,
                    stepSize: 1,
                },
            },
        },
    }

    return (
        <GraphContainer>
            <Bar data={data} options={options} />
        </GraphContainer>
    )
}
